import React, { useEffect, useState } from 'react';
import { useTable, usePagination } from 'react-table';
import { useParams } from 'react-router-dom';
import uploadDocumentToCar from '../../api/cars/uploadDocumentToCar';
import getCarDocuments from '../../api/cars/getCarDocuments';
import { CAR_DOCUMENT_TYPES } from '../../constants';

import HookForm from '../../components/HookForm/HookForm';
import SelectCarDocumentType from '../../components/Selects/SelectCarDocumentType';
import DocsInputNew from '../../components/Inputs/DocsInput/DocsInputNew';
import DeleteButton from '../../components/DeleteButton/DeleteButton';
import AddButton from '../../components/AddButton/AddButton';
import LoaderInline from '../../components/Loader/LoaderInline';
import Button from '../../components/Button/Button';
import EmptyData from '../../components/EmptyData/EmptyData';
import icon from '../../brand/generated/buttonIcons/addDeal.svg';
import { colors } from '../../constants/colors';

const formStyles = {
  document: { display: 'grid', gap: '20px', gridTemplateColumns: `1fr 1fr 1fr 44px`, alignItems: 'end' },
};

const CAR_DOCUMENTS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    width: '4%',
  },
  {
    Header: 'Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
    accessor: (row) => {
      const docType = CAR_DOCUMENT_TYPES.find((doc) => doc.value === row.typeId);
      return docType?.label || 'ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½ÑÐ¹ ÑÐ¸Ð¿';
    },
    width: '30%',
  },
  {
    Header: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
    accessor: 'name',
    width: '30%',
  },
  {
    Header: 'Ð¤Ð°Ð¹Ð»',
    accessor: (row) => (
      <a href={row.url} target="_blank" rel="noreferrer" style={{ color: colors.cameo }}>
        Ð¡ÐºÐ°ÑÐ°ÑÑ
      </a>
    ),
    width: '30%',
  },
  {
    Header: '',
    accessor: 'dots',
    width: '6%',
  },
];

const CarDocs = () => {
  const { id } = useParams();
  const row = () => [
    { component: SelectCarDocumentType, name: 'typeId' },
    { name: 'name', label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°', placeholder: 'ÐÐ°Ð¿ÑÐ¸Ð¼ÐµÑ, "ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ ÐºÑÐ¿Ð»Ð¸-Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸ ÐÐµÐºÐ¿ÑÐ»Ð°ÑÐ¾Ð²"' },
    {
      component: DocsInputNew,
      name: 'file',
      label: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      text: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      id: Math.random(),
    },
    {
      component: DeleteButton,
      name: 'delete',
      onClick: (e, index) => {
        removeRow(e, index);
      },
    },
  ];
  const [form, setForm] = useState([row()]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  const table = useTable(
    {
      columns: CAR_DOCUMENTS_COLUMNS,
      data: documents,
      initialState: { pageIndex: 0, pageSize: 1000000 },
    },
    usePagination
  );

  const init = async () => {
    setLoading(true);
    const array = [];
    await getCarDocuments({ carId: id }).then((res) => {
      if (res.data) {
        res.data.forEach((item) => {
          array.push({
            id: item.id,
            typeId: item.typeId,
            name: item.name,
            url: item.url,
          });
        });
      }
    });
    setDocuments([...array]);
    setLoading(false);
  };

  const addRow = () => {
    setForm([...form, row()]);
  };

  const removeRow = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const newForm = form;
    newForm.slice(index, 1);
    setForm(newForm);
  };

  const onSubmit = () => {
    setLoading(true);
    const fields = form.map((i) => i.map((i) => i.value?.value || i.value));
    Promise.all(
      fields.map((field) =>
        uploadDocumentToCar({
          carId: id,
          typeId: field[0],
          name: field[1],
          file: field[2],
        })
      )
    ).finally(() => {
      init();
    });
  };

  useEffect(() => {
    init();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}>
        <LoaderInline />
      </div>
    );
  }

  return (
    <div
      style={{ padding: '0 20px 20px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}
    >
      <EmptyData
        title={`ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ (${documents.length})`}
        subtitle={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ñ'}
        action={null}
        icon={icon}
        table={table}
        data={documents}
      />

      {form.map((row, index) => (
        <HookForm grid={formStyles.document} inputs={row} style={{ margin: 0 }} index={index} />
      ))}

      <div style={{ marginTop: -30, paddingLeft: 20 }}>
        <AddButton text="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ" onClick={addRow} />
        <div
          style={{
            marginTop: 20,
          }}
        >
          <Button text="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ" fill onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
};

export default CarDocs;
